import React, { Component } from "react";
import { Pie } from "react-chartjs-2";
import { Card, CardBody, CardText } from "reactstrap";
import {getMessage} from "./util";

class RolloutSummary extends Component {

  render() {
      var labels = [getMessage('label_ready',this.props.messages), getMessage('label_electronic_voted',this.props.messages)];
      var datain = [
              this.props.snapshot.voters.ready,
              this.props.snapshot.voters.electronic_voted
            ];

      if (this.props.snapshot.voters.manual_voted > 0) {
        labels.push(getMessage('label_paper_voted',this.props.messages));
        datain.push(this.props.snapshot.voters.manual_voted);
      }
      const data = {
        labels: labels,
        datasets: [
          {
            data: datain,
            backgroundColor: ["#C6CCD4", "#0B1224"],
            hoverBackgroundColor: ["#C6CCD4", "#0B1224"]
          }
        ]
      };

      const chartOptions = {
        legend: {
          position: "top"
        }
      };

      return (
        <div>
          <div className="row">
            <div className="col-12 col-sm-8">
              <Pie data={data} options={chartOptions} />
            </div>
            <div className="col-12 col-sm-4">
              <div className="row justify-content-center">
                <div className="col-6 col-sm-10 mt-2">
                  <BoxInfo
                    percentage={(
                      (100 * (this.props.snapshot.voters.electronic_voted+this.props.snapshot.voters.manual_voted)) /
                      (this.props.snapshot.voters.electronic_voted+
                          this.props.snapshot.voters.manual_voted+
                          this.props.snapshot.voters.ready+
                          this.props.snapshot.voters.registered)
                    )
                      .toFixed(2)
                      .toLocaleString(navigator.language, {
                        minimumFractionDigits: 2
                      })}
                    progress={(
                      this.props.snapshot.voters.electronic_voted +
                      this.props.snapshot.voters.manual_voted
                    ).toLocaleString(navigator.language, {
                      minimumFractionDigits: 0
                    })}
                    total={(
                      this.props.snapshot.voters.electronic_voted +
                      this.props.snapshot.voters.manual_voted +
                      this.props.snapshot.voters.ready
                    ).toLocaleString(navigator.language, {
                      minimumFractionDigits: 0
                    })}
                    label={getMessage('total_voters',this.props.messages)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }


class BoxInfo extends Component {
  render() {
    return (
      <div>
        <Card>
          <CardBody>
            <CardText>
              <b>{this.props.percentage} %</b>
              <br />({this.props.progress} de {this.props.total})<br />
              {this.props.label}
            </CardText>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default RolloutSummary;
